import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { Helmet, HelmetProvider } from "react-helmet-async";
import { RegionProvider } from './context/RegionContext.tsx';
import { getRegionConfig } from './lib/regionConfig.ts';

import './index.css';

// Conditional preloading for background images
const preloadBackgroundImage = () => {
  // Only preload if we're on a route that uses the background
  const shouldPreload = window.location.pathname === '/' || window.location.pathname.includes('/ai');

  if (shouldPreload) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = '/home/background.webp';
    link.as = 'image';
    document.head.appendChild(link);
  }
};

// Preload when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', preloadBackgroundImage);
} else {
  preloadBackgroundImage();
}

const regionConfig = getRegionConfig();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
        <Helmet>
        <title>{regionConfig.seoTitle}</title>
        <meta name="description" content={regionConfig.seoDescription} />
        <meta name="keywords" content={regionConfig.seoKeywords} data-hid="keywords"/>
    </Helmet>
    <RegionProvider>
      <App />
    </RegionProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
